import { useState, useEffect } from 'react';
import { Code2 } from 'lucide-react';

export default function LoadingScreen() {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade-out after 500ms
    const fadeTimer = setTimeout(() => setFadeOut(true), 500);
    // Remove from DOM after fade completes (500ms fade + 500ms display)
    const removeTimer = setTimeout(() => setVisible(false), 1000);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background"
      style={{
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 0.5s ease-out',
        pointerEvents: fadeOut ? 'none' : 'auto',
      }}
    >
      <div className="flex items-center gap-3">
        <Code2 className="h-10 w-10 text-primary" />
        <span className="text-2xl font-bold text-foreground">Innovation Coders</span>
      </div>
      <div className="mt-6 h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}
